import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { getAuthErrorMessage } from '../utils/errorMessages';
import { Button, Input, Heading, Text } from './ui';
import '../styles/Login.css';

const MailIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await authService.sendPasswordResetEmail(email);
      setMessage('Check your email for password reset instructions.');
      setEmail('');
    } catch (error) {
      setError(getAuthErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-container">
          <img src="/FullLogo.png" alt="Housfully" className="logo" />
        </div>
        <Heading level={1} tone="dark" className="preview-title">
          Reset Password
        </Heading>
        <Text tone="dark" className="reset-description">
          Enter your email address and we'll send you instructions to reset your
          password.
        </Text>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <Input
            tone="dark"
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            placeholder="Enter your email address"
            leadingIcon={MailIcon}
          />
          <Button
            type="submit"
            tone="dark"
            variant="primary"
            fullWidth
            loading={loading}
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Email'}
          </Button>
        </form>
        <p className="auth-link">
          Remember your password?&nbsp;&nbsp;&nbsp;
          <Link to="/signin">Log In</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
